import { z } from 'zod'

import { filterItemSchema } from './FilterItem.ts'

export const filterResponseSchema = z.object({
	filterItems: z.array(filterItemSchema)
})

export type FilterResponse = z.infer<typeof filterResponseSchema>
